import React, { useState } from 'react';
import { Image, Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import Link from '../../../core/Components/Link';
import ModalVideo from 'react-modal-video';

const TwoUpCtaDiagram = ({ fields }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const colorVarient = fields.colors.fields.Title.value;
  const imageStyle = fields.style.fields.Title.value;
  const imagePosition = fields.imagealignment.value;
  return (
    <div
      className={`two-up-cta-diagram-container ${colorVarient}`}
      id={fields.Id.value}
    >
      <div
        className={`two-up-cta-diagram-container-width ${imageStyle} ${
          imagePosition ? 'image-top' : ''
        }`}
      >
        <div className="two-up-cta-diagram-container-width-content">
          <div className="two-up-cta-diagram-container-width-content-heading">
            <Text field={fields.title} />
          </div>
          <div className="two-up-cta-diagram-container-width-content-description">
            <RichText field={fields.description} />
          </div>
          {fields.link.value.href ? (
            <div className="two-up-cta-diagram-container-width-content-link">
              <Link field={fields.link} className="cta-button secondary" />
            </div>
          ) : null}
        </div>
        {fields.backgroundImage.value.src ? (
          <div className="two-up-cta-diagram-container-width-image-section">
            <div className="image-video-container">
              <Image field={fields.backgroundImage} />
              {fields.videoId.value !== null && fields.videoId.value !== '' ? (
                <button
                  className="video-modal-cta"
                  type="button"
                  onClick={() => setIsModalOpen(true)}
                  aria-label="Play video"
                />
              ) : null}
            </div>
            <ModalVideo
              channel="youtube"
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              videoId={fields.videoId.value}
              youtube={{
                autoplay: 1,
                enablejsapi: 1,
                rel: 0,
              }}
            />
          </div>
        ) : (
          <div
            className={`two-up-cta-diagram-container-width-image-section ${
              imagePosition ? 'image-top' : ''
            }`}
          >
            <div
              className={`two-up-cta-diagram-container-width-image-section-image ${
                imagePosition ? 'image-top' : ''
              }`}
            >
              <Image field={fields.image} />
            </div>
            <div
              className={`two-up-cta-diagram-container-width-image-section-textblocks ${colorVarient}  ${
                imagePosition ? 'image-top' : ''
              }`}
            >
              {fields.textBlocks.map((block, index) => {
                return (
                  <div className="two-up-cta-diagram-container-width-image-section-textblocks-block">
                    <p className="two-up-cta-diagram-container-width-image-section-textblocks-block-index">
                      {index + 1}.
                    </p>
                    <RichText
                      className="two-up-cta-diagram-container-width-image-section-textblocks-block-text"
                      field={block.fields[`Block Text`]}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {fields.breakLine.value ? <div className="break-line" /> : null}
    </div>
  );
};

export default TwoUpCtaDiagram;
